<template>
  <div class="form-group document-classroom-education">
    <form class="uk-child-width-1-3@s uk-grid-small p-4" uk-grid>
      <div>
        <h5 class="uk-text-bold mb-2">
          {{ $t('general.instructor_name') }}<span class="required">*</span>
        </h5>
        <multiselect 
          :value="value.instructor_name"
          @input="updateField('instructor_name', $event)"
          :allow-empty="true" 
          :multiple="false"
          :openDirection="'bottom'" 
          :options="instructorNames" 
          :placeholder="$t('general.select')"
          :searchable="true" 
          :tag-placeholder="$t('general.select')" 
          :taggable="true"
          :deselectLabel="$t('general.please_enter_to_remove')" 
          :selectLabel="$t('general.press_enter_to_select')"
          @tag="addInstructorName">
          <template slot="noOptions"><span>{{ $t('general.no_options') }}</span></template>
        </multiselect>
      </div>
      
      <div>
        <h5 class="uk-text-bold mb-2">{{ $t('general.accommodation_cost') }}</h5>
        <input 
          :value="value.accommodation_cost"
          @input="updateField('accommodation_cost', $event.target.value)"
          class="form-control" 
          min="0"
          :placeholder="$t('general.enter_a_number')" 
          step="any" 
          type="number" 
        />
      </div>
      
      <div>
        <h5 class="uk-text-bold mb-2">
          {{ $t('general.place_of_education') }}<span class="required">*</span>
        </h5>
        <multiselect 
          :value="value.education_place"
          @input="updateField('education_place', $event)"
          :allow-empty="true" 
          :multiple="false"
          :options="educationPlaces" 
          :placeholder="$t('general.select')" 
          :searchable="true"
          :tag-placeholder="$t('general.select')" 
          :taggable="true" 
          deselectLabel=""
          :selectLabel="$t('general.select')" 
          @tag="addEducationPlace">
          <template slot="noOptions"><span>{{ $t('general.no_options') }}</span></template>
        </multiselect>
      </div>
      
      <div>
        <h5 class="uk-text-bold mb-2">{{ $t('general.education_cost') }}</h5>
        <input 
          :value="value.education_cost"
          @input="updateField('education_cost', $event.target.value)"
          class="form-control" 
          min="0" 
          :placeholder="$t('general.enter_a_number')"
          step="any" 
          type="number" 
        />
      </div>
      
      <div>
        <h5 class="uk-text-bold mb-2">{{ $t('general.transportation_cost') }}</h5>
        <input 
          :value="value.transportation_cost"
          @input="updateField('transportation_cost', $event.target.value)"
          class="form-control" 
          min="0"
          :placeholder="$t('general.enter_a_number')" 
          step="any" 
          type="number" 
        />
      </div>
      
      <div>
        <h5 class="uk-text-bold mb-2">{{ $t('general.training_place_cost') }}</h5>
        <input 
          :value="value.education_place_cost"
          @input="updateField('education_place_cost', $event.target.value)"
          class="form-control" 
          min="0"
          :placeholder="$t('general.enter_a_number')" 
          step="any" 
          type="number" 
        />
      </div>
      
      <div>
        <h5 class="uk-text-bold mb-2">{{ $t('general.capacity') }}</h5>
        <input 
          :value="value.capacity"
          @input="updateField('capacity', $event.target.value)"
          class="form-control" 
          min="0" 
          :placeholder="$t('general.enter_a_number')"
          type="number" 
        />
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "DocumentClassroomEducation",
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        instructor_name: "",
        accommodation_cost: "",
        education_place: "",
        education_cost: "",
        transportation_cost: "",
        education_place_cost: "",
        capacity: ""
      })
    },
    instructorNames: {
      type: Array,
      default: () => []
    },
    educationPlaces: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateField(field, value) {
      this.$emit('input', {
        ...this.value,
        [field]: value
      });
    },
    addInstructorName(newTag) {
      this.$emit('add-instructor-name', newTag);
    },
    addEducationPlace(newTag) {
      this.$emit('add-education-place', newTag);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

